export const myNewsAdminSettingsPageMenuDef = [
  {
    id: "myNewsGeneralSettings",
    label: "OC_GENERAL_SETTINGS",
    roles: ["MyNews.admin"],
  },
];
